export const KintoneExportMetadataFieldCorrespondences = {
  procedureNameFieldCode: ["SINGLE_LINE_TEXT"],
  submissionIdFieldCode: ["SINGLE_LINE_TEXT"],
  submittedAtFieldCode: ["DATE", "DATETIME"],
  submissionStatusFieldCode: ["DROP_DOWN"],
} as const;
